import { Injectable } from '@angular/core';
import { ApiService } from '../apiAndObjects/api/api.service';
import { DictionaryType } from '../apiAndObjects/api/dictionaryType.enum';
import { Dictionary } from '../apiAndObjects/public_api';

@Injectable()
export class DictionaryService {
  constructor(private apiService: ApiService) {}

  public getDictionary(type: DictionaryType): Promise<Dictionary> {
    return this.apiService.getDictionary(type);
  }
  public getDictionaries(types: Array<DictionaryType>): Promise<Array<Dictionary>> {
    return this.apiService.getDictionaries(types);
  }
}
